// The shell's stylesheets first, in the shell's own order, for its tokens and the menus, palette
// and dialogs the page shares with it; then the aligner's own rules (ADR 0030 decision 2). They
// are bundled into dist/align/align.css rather than linked from dist/shell.css, so the page loads
// nothing the shell's offline manifest names and the shell's worker never answers for it.
import 'dockview/dist/styles/dockview.css'
import '../../../editor/editor.css'
import '../shell.css'
import { createRoot } from 'react-dom/client'
import { App } from './app/App.tsx'
import './align.css'

createRoot(document.getElementById('app')!).render(<App />)
